import { render, staticRenderFns } from "./ValidationMessages.vue?vue&type=template&id=27034efb&scoped=true&"
import script from "./ValidationMessages.vue?vue&type=script&lang=js&"
export * from "./ValidationMessages.vue?vue&type=script&lang=js&"
import style0 from "./ValidationMessages.vue?vue&type=style&index=0&id=27034efb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27034efb",
  null
  
)

export default component.exports